import React from "react"
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import Img from 'gatsby-image'
import { rhythm } from "../utils/typography"

import capitalize from 'capitalize'

import Section from '../com/Section'
import Background from '../com/Background'
import BackgroundMobile from '../com/BackgroundMobile'
import BackgroundTablet from '../com/BackgroundTablet'
import BackgroundWideScreen from '../com/BackgroundWideScreen'
import Crosshairs from '../com/Crosshairs'
import Content from '../com/Content'
import Title from '../com/Title'
import Tag from '../com/Tag'
import P from '../com/P'
import Ul from '../com/Ul'
import BlogGallery from '../com/BlogGallery'
import BlogTile from '../com/BlogTile'
import Cta from '../com/Cta'
import CtaAnimated from '../com/CtaAnimated'
import SeeGrid from '../com/SeeGrid'
import H1 from '../com/H1'
import H2 from '../com/H2'

import presets from '../utils/presets'
import mirageMobileVideo from '../../static/mirage.mp4'

const IndexPage = ({ data }) => (
<div>
<Helmet>

    <title>{data.site.siteMetadata.tag} | {data.site.siteMetadata.title}</title>
    <meta name="description" content="We make awesome computer generated videos and images." />

    <meta property="og:title" content={data.site.siteMetadata.title} />
    <meta property="og:description" content={data.site.siteMetadata.description} />
    <meta property="og:url" content={data.site.siteMetadata.url} />
    <meta property="og:type" content="website" />
    <meta property="og:image" content={`${data.site.siteMetadata.url}${data.og.resize.src}`} />
    <meta property="og:image:width" content={data.og.resize.width} />
    <meta property="og:image:height" content={data.og.resize.height} />
    <meta property="og:image:alt" content="Awesome Computer Generated Imagery" />
    <meta property="og:image:secure_url" content={`${data.site.siteMetadata.url}${data.og.resize.src}`} />
    <meta property="og:site_name" content={data.site.siteMetadata.title} />
    <meta property="og:locale" content="en_GB" />
    <meta property="og:locale:alternate" content="en_US" />

</Helmet>
<Section>
  <Background>
    <video preload="auto" muted="true" muted autoPlay loop playsInline poster={data.poster.resize.src}>
      <source src={mirageMobileVideo} type="video/mp4" />
      <p>Your browser does not support the video tag.</p>
    </video>
    {/* <Crosshairs /> */}
  </Background>
  <Content>
    <H1 light>we make awesome imagery</H1>
    <P brand>
      3D computer generated videos and photo-realistic images to show off your brand, products and services from a UK-based VFX studio.
    </P>
    <Tag>attention-grabbing visual content for your online experiences, landing pages, website and exhibitions.</Tag>
    <Cta to="/contact/">let&apos;s talk.</Cta>
    {/* <CtaAnimated to="/#stuff-we-made">see</CtaAnimated> */}
  </Content>
</Section>

<H2 style={{textAlign:`center`}}>stuff we've made</H2>


<SeeGrid id="stuff-we-made">
  {data.allSeeYaml.edges.map(({ node }) => (


      <Link
        key={node.id}
        to={`${node.fields.slug}`}
        style={{position:`relative`}}
        alt={node.title} title={node.title}>
        <Img
          sizes={node.image.childImageSharp.sizes}
          alt={node.title}
        />
        <Tag>{node.title}</Tag>
        {(node.video != null ?
          <P
            style={{
              position:`absolute`,
              top:`0`,
              left:`0`,
              fontSize:`${rhythm(0.5)}`,
              marginTop:`${rhythm(0.25)}`,
              marginLeft:`${rhythm(0.25)}`,
            }}>&#9654;[video]
          </P> : "" )}
      </Link>


    ))}
</SeeGrid>

<div style={{textAlign:`center`,}}>
  <Cta to="/see/">see more</Cta>
</div>

<Content>
  <H1>what else?</H1>
  <Ul>
    <li>awesome landing page code, a bit like this one</li>
    <li>concept design</li>
    <li>graphic design</li>
    <li>branding & identity design</li>
  </Ul>
  <Tag>We&rsquo;re problem solvers and learners. We thrive on challenge. If you have an idea you can't quite bring to life, come and say hi.</Tag>
  <Tag>Or maybe you just want a new product to look <Link to="/see/">amazing...</Link></Tag>
  <Cta to="/subscribe/">follow us</Cta>
</Content>

<Section style={{height:`110vh`}}>
  <BackgroundMobile>
      <Img sizes={data.hero.mobile}
        position={'relative'}
        alt={'Grill on Deck'}
        style={{
          height:`100vh`,
        }}
      />
    {/* <Crosshairs /> */}
  </BackgroundMobile>
  <BackgroundTablet>
      <Img sizes={data.hero.tablet}
        position={'relative'}
        alt={'Grill on Deck'}
        style={{
          height:`100vh`,
        }}
      />
  </BackgroundTablet>
  <BackgroundWideScreen>
      <Img sizes={data.hero.widescreen}
        position={'relative'}
        alt={'Grill on Deck'}
        style={{
          height:`110vh`,
        }}
      />
  </BackgroundWideScreen>
  {/* <Content>
    <H1 light>what else?</H1>
    <Ul brand>
      <li>awesome landing page code, a bit like this one</li>
      <li>concept design</li>
      <li>graphic design</li>
      <li>branding & identity design</li>
    </Ul>
    <Tag>We&rsquo;re problem solvers and learners. We thrive on challenge. If you have an idea you can't quite bring to life, come and say hi.</Tag>
    <Tag>Or maybe you just want a new product to look <Link to="/see/">amazing...</Link></Tag>
    <Cta to="/subscribe/">follow us</Cta>
  </Content> */}

  <Content>
    <Cta to="/subscribe/">follow us</Cta>
  </Content>

</Section>

</div>
);

export default IndexPage

export const query = graphql`
  query IndexPageQuery {
    hero:imageSharp(id: { regex: "/decking/" }) {
      id
      sizes(maxWidth: 2560) {
      ...GatsbyImageSharpSizes
      }
      mobile:resolutions(width:1440, height:2560, quality: 50, cropFocus: CENTER) {
      ...GatsbyImageSharpResolutions
      }
      tablet:resolutions(width:2048, height:2960, quality: 50, cropFocus: CENTER) {
      ...GatsbyImageSharpResolutions
      }
      widescreen:resolutions(width:2560, height:1440, quality: 65, cropFocus: CENTER) {
      ...GatsbyImageSharpResolutions
      }
    }
    poster:imageSharp(id: { regex: "/mirage-high/" }) {
      id
      resize(width:640, height:640, grayscale: true, cropFocus:CENTER,) {
        src
      }
    }
    og:imageSharp(id:{regex:"/mirage-high/"}){
      id
      resize(width:1920, height:1080, grayscale: true, cropFocus:CENTER,){
        src
        width
        height
      }
    }
    allSeeYaml (filter:{onhome:{eq:true}}) {
      edges{
        node{
          onhome
          id
          title
          date (formatString: "DD MMM YYYY")
          image{
            childImageSharp{
              sizes (maxWidth: 800){
                sizes
                base64
                src
                srcSet
              }
            }
          }
          fields{
            slug
          }
          video{id}
        }
      }
    }
    site{
      siteMetadata{
        title
        url
        description
        tag
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js